/*
 * スマートフォンのアドレスバーなどが表示されている状態の画面の高さを取得して、css変数に代入
 */
export class FirstHeight {
	static setProperty() {
		const h = window.innerHeight;
		document.documentElement.style.setProperty("--first-height", h + "px");
	}
}
